import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import NavigationLinks from './navigation-links'
const MenuTop = () => {
  const data = useStaticQuery(graphql`
    {
      maintop: allDatoCmsPctNavigation(
        filter: { codeId: { eq: "navigation-top-navigation" } }
      ) {
        nodes {
          navigationItems {
            ...PctNavigationItems
          }
        }
      }
    }
  `)
  const links = data?.maintop?.nodes[0].navigationItems[0].navigationLinks
  return (
    <NavigationLinks
      className="main-menu-top"
      items={links}
      showDescription={false}
    />
  )
}

export default MenuTop
